import menu from "@/constants/menu";

/**
 * Check if user has a specific permission
 */
export function hasPermission(permission, userPermissions) {
  if (!userPermissions || !permission) return false;
  // Convert to array if it's a Collection or other iterable
  const permissionsArray = Array.isArray(userPermissions) 
    ? userPermissions 
    : Array.from(userPermissions || []);
  return permissionsArray.indexOf(permission) !== -1;
}

/**
 * Get the first page from menu that user has permission to access
 */
export function getFirstAllowedPage(userPermissions) {
  // Convert to array if needed
  const permissionsArray = Array.isArray(userPermissions) 
    ? userPermissions 
    : Array.from(userPermissions || []);
  
  // Helper function to check if user has permission for a menu item
  const checkPermission = (item) => {
    if (!item.permission) return true; // No permission required
    return hasPermission(item.permission, permissionsArray);
  };

  // Iterate through menu items
  for (const item of menu) {
    // Skip headers and dividers
    if (item.header || item.divider) continue;

    // If item has sub-items, check first sub-item
    if (item.items && item.items.length > 0) {
      for (const subItem of item.items) {
        if (subItem.name && checkPermission(subItem)) {
          return { name: subItem.name };
        }
      }
    }
    // If item has a name and user has permission
    else if (item.name && checkPermission(item)) {
      return { name: item.name };
    }
  }

  // Fallback to Requests if no page found (shouldn't happen)
  return { name: "Requests" };
}

/**
 * Get permission required for a route name from menu
 */
export function getRoutePermission(routeName) {
  if (!routeName) return null;
  
  // Helper function to search in menu items
  const searchInItems = (items) => {
    for (const item of items) {
      if (item.name === routeName) {
        return item.permission || null;
      }
      if (item.items && item.items.length > 0) {
        const found = searchInItems(item.items);
        if (found !== null) return found;
      }
    }
    return null;
  };
  
  return searchInItems(menu);
}

/**
 * Check if user has permission to access a route by name
 */
export function canAccessRoute(routeName, userPermissions) {
  if (!routeName) return false;
  
  const permission = getRoutePermission(routeName);
  if (!permission) return true; // No permission required
  
  return hasPermission(permission, userPermissions);
}
